module.exports = __webpack_public_path__ + "static/media/image1.5e67149c.jpg";